export default "__VITE_ASSET__DlCWosy3__"